import { THPXModulesManagementDataTableData } from "./HPXModulesManagementDataTableMeta";

const hPXModulesManagementFakeDataTableData: THPXModulesManagementDataTableData[] = [
    {
        primaryKey: 1,
        identifier: "M000",
        name: "",
        isVisible: true,
        image: "homepage6",
        menu: "",
        icon: "",
        order: 0,
        attachment: "",
    },
    {
        primaryKey: 2,
        identifier: "M075",
        name: "Archivage",
        isVisible: true,
        image: "homepage6",
        menu: "toolbar_archive",
        icon: "",
        order: 1,
        attachment: "",
    },
    {
        primaryKey: 3,
        identifier: "M020",
        name: "Gestion Transactions",
        isVisible: true,
        image: "homepage6",
        menu: "toolbar_transaction",
        icon: "",
        order: 2,
        attachment: "",
    },
    {
        primaryKey: 4,
        identifier: "M005",
        name: "Gestion Porteurs",
        isVisible: true,
        image: "homepage6",
        menu: "toolbar_cardholder",
        icon: "",
        order: 2,
        attachment: "",
    },
    {
        primaryKey: 5,
        identifier: "M007",
        name: "Gestion Commerçant",
        isVisible: true,
        image: "homepage6",
        menu: "toolbar_hpx",
        icon: "",
        order: 2,
        attachment: "",
    },
    {
        primaryKey: 6,
        identifier: "M004",
        name: "Gestion interfaces",
        isVisible: true,
        image: "homepage6",
        menu: "toolbar_switch",
        icon: "",
        order: 6,
        attachment: "",
    },
    {
        primaryKey: 7,
        identifier: "M014",
        name: "Gestion Débit",
        isVisible: true,
        image: "homepage6",
        menu: "toolbar_debit",
        icon: "",
        order: 10,
        attachment: "",
    },
    {
        primaryKey: 8,
        identifier: "M009",
        name: "Revolving Credit",
        isVisible: false,
        image: "homepage6",
        menu: "credit_toolbar",
        icon: "",
        order: 10,
        attachment: "",
    },
    {
        primaryKey: 9,
        identifier: "M101",
        name: "GIMAC",
        isVisible: true,
        image: "GIMAC",
        menu: "toolbar_gimac",
        icon: "",
        order: 10,
        attachment: "",
    },
    {
        primaryKey: 10,
        identifier: "M010",
        name: "Gestion Prépayé",
        isVisible: true,
        image: "homepage6",
        menu: "toolbar_pre_paid",
        icon: "",
        order: 10,
        attachment: "",
    },


];

export default hPXModulesManagementFakeDataTableData;